import Grid from '@/global/components/ui/Grid'
import {
    FormDatePicker,
    FormField,
    FormFieldTime,
    FormFile,
} from 'global/components/Form'

export default function FormNovoRegistro() {
    return (
        <Grid container>
            <Grid item xs={12} sm={6}>
                <FormDatePicker name="data" label="Data" type="date" required />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormFieldTime name="hora" label="Hora" required />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="justificativa"
                    label="Justificativa"
                    required
                    multiline
                    max={190}
                />
            </Grid>
            <Grid item xs={12}>
                <FormFile name="fileUrl" />
            </Grid>
        </Grid>
    )
}
